import logger from './logger';
import { setConfigFeatures } from './config';

const VERSION1 = '/api/v1';

const makeRequest = async (url, params) => {
  try {
    const response = await fetch(url, params);
    const result = await response.json();

    if (result.status >= 400) {
      const errorMessage = `Error ${result.status}: ${result.message} ${result.id}`;
      logger(errorMessage);
      return {
        error: errorMessage,
      };
    }
    return result;
  } catch (e) {
    logger(e.message);
    return {
      error: e.message,
    };
  }
};

const get = async (url) =>
  await makeRequest(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      Pragma: 'no-cache',
    },
  });

export const getConfig = async (apiHost) => {
  const config = await get(`${apiHost}${VERSION1}/config`);
  setConfigFeatures(config);
  return config;
};

// *********************** ANALYTICS EVENTS ******************************

export const sendAnalytics = (eventData) => {
  const encodedParams = Object.entries(eventData)
    .filter((entry) => !!entry[1])
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&');

  const CONFIG = window.config || {};
  const analyticsUrl = CONFIG.GRADEBOOK_ANALYTICS_URL;

  const analyticsEventUrl = `${analyticsUrl}?${encodedParams}`;

  return makeRequest(analyticsEventUrl, {
    method: 'GET',
    mode: 'no-cors',
    headers: {
      Accept: 'application/json',
      Pragma: 'no-cache',
    },
  });
};
